/**
 * Утилита для именования результирующих файлов (транскрипт, протокол).
 * Имя строится из имени исходного аудио/видео + краткого суффикса вида.
 */

/**
 * Построить имя результирующего файла из имени исходника.
 *
 * «Совещание 25 мая.mp3» + ('trnscr', 'txt') → «Совещание 25 мая_trnscr.txt».
 * Если источника нет (микрофон, вставленный текст) — возвращает «<suffix>.<ext>».
 * Запрещённые в имени файла символы (/ \ : * ? " < > |) вычищаются,
 * длина базы ограничена 120 символами.
 *
 * @param {string} sourceName - имя исходного файла (с расширением или без)
 * @param {string} suffix - краткий суффикс вида: 'trnscr' (транскрипт) или 'prtcl' (протокол)
 * @param {string} ext - расширение результата без точки: 'txt', 'docx', 'pdf', 'json'
 * @returns {string} имя файла для атрибута download
 */
export function buildDownloadName(sourceName, suffix, ext) {
  const raw = (sourceName || '').trim();
  // Отрезаем расширение; у имени без точки расширения нет — берём как есть.
  const withoutExt = raw.includes('.') ? raw.split('.').slice(0, -1).join('.') : raw;
  const base = withoutExt
    .replace(/[/\\:*?"<>|]+/g, ' ') // запрещённые в FS символы → пробел
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 120)
    .trim();
  return base ? `${base}_${suffix}.${ext}` : `${suffix}.${ext}`;
}
